import { isFeatureEnabled } from 'owa-feature-flags';
import { orchestrator } from 'satcheljs';
import {
    setPanesSize,
    setRightPaneDisplay,
    updatePanesSize,
} from '../actions/setPaneDisplayActions';
import SxSViewState, { RightPaneDisplay } from '../store/schema/SxSViewState';
import {
    READING_PANE_DEFAULT_PERCENT_SIZE,
    V2_MIN_READING_PANE_WIDTH,
    V2_READING_PANE_DEFAULT_PERCENT_SIZE,
} from '../utils/sxsConstants';

const updatePanesSizeOrchestratorFunction = (
    viewState: SxSViewState,
    parentElementWidth: number
) => {
    const rightPaneSize =
        viewState.rightPaneSize &&
        viewState.rightPaneDisplay !== undefined &&
        viewState.rightPaneDisplay !== RightPaneDisplay.Initial
            ? viewState.rightPaneSize / 100
            : viewState.minRightPaneWidth === V2_MIN_READING_PANE_WIDTH
            ? V2_READING_PANE_DEFAULT_PERCENT_SIZE / 100
            : READING_PANE_DEFAULT_PERCENT_SIZE / 100;
    if (
        viewState.rightPaneDisplay === undefined ||
        viewState.rightPaneDisplay === RightPaneDisplay.Initial
    ) {
        setRightPaneDisplay(
            viewState,
            isFeatureEnabled('doc-SxS-hideEmail')
                ? RightPaneDisplay.Hide
                : RightPaneDisplay.Adaptive
        );
    }
    setPanesSize(
        viewState,
        parentElementWidth * (1 - rightPaneSize),
        parentElementWidth * rightPaneSize
    );
};

orchestrator(updatePanesSize, actionMessage => {
    const { viewState, parentElementWidth } = actionMessage;
    updatePanesSizeOrchestratorFunction(viewState, parentElementWidth);
});

export { updatePanesSizeOrchestratorFunction }; // exported for unit tests
